import {CompositeReport} from "../../../../api/composite/report/CompositeReportApi";
import {NavLink, ScrollArea, SimpleGrid, Stack, Transition} from "@mantine/core";
import CommentsPreviewCard from "../../../workspace/work-panel/cards/comments/preview/CommentsPreviewCard";
import AddSimpleCommentCard from "../../../workspace/work-panel/cards/add-simple-comment/AddSimpleCommentCard";
import CardWrapper from "../../../workspace/work-panel/cards/CardWrapper";
import DeviceCard from "../../../../components/device/cards/DeviceCard";

export type CompositeReportWorkCardsAttrs = {
    isVisible: boolean;
    report: CompositeReport | undefined;
    reloadReport: () => void;
}

export type RelatedReportsCardProps = {
  compositeReport: CompositeReport;
  reload: () => void;
}

export const RelatedReportsCard = (props: RelatedReportsCardProps) => {
  const { compositeReport } = props;

  return (
    <CardWrapper loading={props.compositeReport === undefined} title="Powiązane raporty">
      <ScrollArea h={150}>
        { compositeReport?.overlappingFailureReports?.map((related) => (
          <NavLink key={related.id} href={`/composite/report/excel-details/${related.id}`} label={related.title}/>
        )) }
      </ScrollArea>
    </CardWrapper>
  )
}

function CompositeReportWorkCards(attrs: CompositeReportWorkCardsAttrs) {
    return (
        <Transition mounted={attrs.isVisible} transition='pop'>
            { styles =>
                <SimpleGrid style={styles} mb="xl" cols={{base: 1, sm: 1, md: 2, lg: 3}} spacing={{base: 10, sm: 'xl'}} verticalSpacing={{base: 'sm', sm: 'md'}}>
                    {/*<ValidationCard*/}
                    {/*    compositeReport={attrs.report}*/}
                    {/*/>*/}

                    <CommentsPreviewCard
                        reload={attrs.reloadReport}
                        compositeReport={attrs.report}
                    />

                    <DeviceCard reload={attrs.reloadReport} device={attrs.report?.devices?.at(0)}/>

                    <Stack gap="md">
                      <AddSimpleCommentCard
                        reload={attrs.reloadReport}
                        compositeReport={attrs.report}
                      />

                      <RelatedReportsCard
                        reload={attrs.reloadReport}
                        compositeReport={attrs.report}
                      />
                    </Stack>
                </SimpleGrid>
            }
        </Transition>
    )
}

export default CompositeReportWorkCards;